module.exports = __webpack_public_path__ + "img/NUCLEO_BUEN_ESTADO.png";